// extracted by mini-css-extract-plugin
export default {"main":"AboutUs_main__wRcWY","content":"AboutUs_content__hWsRu","title":"AboutUs_title__iVeA0","mainContainer":"AboutUs_mainContainer__jRftr"};